<template>
    <div class="num-input" v-if="componentShow">
        <!--<el-tooltip  :disabled="tipdisable" class="item" effect="dark" :content="tipContent" placement="top">-->
        <el-input-number ref="zmNumImput" v-model="newValue" :precision="precision" :controls=false :disabled="disabled" :min="min"
                         :name="name"   @focus="numFocus"   :step="step"     :max="max"  @change="change" @blur="blur"></el-input-number>
        <!--</el-tooltip>-->
    </div>
</template>

<script>
    export default {
        name: "NumInput",
        props: {
            value:{
                type:Number
            },
            precision:{
                type:Number,
                default:0
            },
            disabled:{
                type:Boolean,
                default:false
            },
            min:{
                type:Number
            },
            max:{
                type:Number
            },
            tabindex:{
                type:String
            },
            name:{
                type:String
            },
            focusSelect:{
                type:Boolean,
                default:false
            },
            step:{
                type:Number,
                default:0
            }
        },
        computed:{
            newValue: {
                get:function() {
                    return this.value;
                },
                set:function(value) {
                    // if(value){
                    //     this.tipdisable = false;
                    //     this.tipContent = (value).toFixed(this.precision).replace(/(\d)(?=(\d{3})+\.)/g, '$1,');
                    // }else{
                    //     this.tipdisable = true;
                    //     this.tipContent = '';
                    // }
                    this.$emit('input', value);
                }
            }
        },
        mounted(){
            if(this.tabindex){
                this.$refs['zmNumImput'].$el.children[0].children[0].setAttribute("tabindex",this.tabindex);
            }
        },
        data(){
            return {
                aa:'',
                componentShow:true,
                // tipdisable:true,
                // tipContent:'',
            }
        },
        methods:{
            change(value){
                this.$emit('change', value);
            },
            blur(event){
                this.$emit('blur', event);
            },
            focus(){
                this.$refs['zmNumImput'].focus();
            },
            select(){
                this.$refs['zmNumImput'].select();
            },
            numFocus(){
                if(this.focusSelect){
                    this.$refs['zmNumImput'].$el.children[0].children[0].select();
                }
                this.$emit('focus');
            }
        },
        beforeDestroy(){
            this.componentShow = false;
        }
    }
</script>

<style>

    .num-input .el-input-number.is-without-controls .el-input__inner {
        padding-left: 4px;
        padding-right: 4px;
    }

</style>


// WEBPACK FOOTER //
// src/components/NumInput/index.vue